export function ServiceCard({ testid, img, name, desc, meta, selected, onClick, noClick, right }) {
  const clickable = !noClick;
  return (
    <div data-testid={testid} onClick={clickable ? onClick : undefined}
      className={`border overflow-hidden flex flex-col sm:flex-row transition-colors ${clickable ? "cursor-pointer" : ""} ${selected ? "border-slate-900" : "border-slate-300 hover:border-slate-500"}`}>
      <div className="sm:w-44 h-40 sm:h-auto shrink-0 overflow-hidden bg-slate-100">
        <img src={img} alt={name} className="w-full h-full object-cover" />
      </div>
      <div className="flex-1 p-5 flex flex-col">
        <div className="flex items-start justify-between gap-4">
          <h3 className="text-lg font-medium leading-snug">{name}</h3>
          <div className="shrink-0" onClick={(e) => { if (noClick) e.stopPropagation(); }}>{right}</div>
        </div>
        <p className="text-sm text-slate-500 mt-2 leading-relaxed">{desc}</p>
        {meta && <div className="mt-auto pt-4"><div className="bg-secondary text-slate-600 text-xs font-mono px-3 py-2">{meta}</div></div>}
      </div>
    </div>
  );
}
